import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { careerJobsGet } from '@/src/lib/prismic/queries';
import { urlHostResolver } from '@/src/lib/utils';
import CareerListingMinimal from '@/src/views/careers/CareerListingMinimal';

function CareersPage({ doc, preview }) {
  return (
    <AssembleLayout
      Layout={MainLayout}
      Component={CareerListingMinimal}
      doc={doc}
      preview={preview}>
      <NextSeo
        title="Carreiras"
        description="Acompanhe as vagas abertas para começar sua história na Eskolare."
        openGraph={{
          title: 'Carreiras',
          url: urlHostResolver(`/careers`),
          images: [
            {
              title: 'Carreiras',
              url: urlHostResolver(`/images/illustrations/blog.png`),
              width: 1125,
              height: 571,
              alt: 'Blog',
            },
          ],
        }}
      />
    </AssembleLayout>
  );
}

CareersPage.propTypes = {
  doc: PropTypes.object,
  preview: PropTypes.bool,
};

export async function getStaticProps(context) {
  const { preview = false, previewData = {} } = context;
  const { ref } = previewData;
  const graphQuery = `{
    careers-job {
      title
      type
      location
    }
  }`;

  const jobs = await careerJobsGet({ graphQuery }, { ref });

  return {
    props: { doc: { jobs }, preview },
    revalidate: 180,
  };
}

export default CareersPage;
